import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';

import {Control, ControlPosition, LatLng, Map} from 'leaflet';
import {ClipboardService} from 'ngx-clipboard';
import {NotificationsService} from 'angular2-notifications';
import {TranslateService} from '@ngx-translate/core';
import {MobileViewService} from 'gelios-ng-admin-components';

@Component({
  selector: 'app-leaflet-info-control',
  templateUrl: './leaflet-info-control.component.html',
  styleUrls: ['./leaflet-info-control.component.scss']
})
export class LeafletInfoControlComponent implements OnInit, OnDestroy {

  private _map: Map;
  public currentPosition: LatLng;
  public lastClickPosition: LatLng;

  @Input() position: ControlPosition ;
  @Input() set map(map: Map) {
    if (map) {
      map.on('click', this.onClick, this);
      map.on('mousemove', this.onMouseMove, this);
    }
  }
  get map(): Map {
    return this._map;
  }
  @Input() geofenceTotalCount: number = null;
  @Input() geofenceReceivedCount: number = null;
  @Input() geopointsTotalCount: number = null;
  @Input() geopointsReceivedCount: number = null;
  @Input() unitTotalCount: number = null;
  @Input() unitReceivedCount: number = null;
  controlPositionsVisibility = false;
  unitCountControlErrorVisibility = false;
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected clipboard: ClipboardService,
    protected notificationsService: NotificationsService,
    protected translateService: TranslateService,
    public mobileViewService: MobileViewService,
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.map) {
      this.map.off('click', this.onClick);
      this.map.off('mousemove', this.onMouseMove);
    }
  }

  resetLastClickPosition() {
    this.lastClickPosition = null;
  }

  openControlContainer(controlName: string) {
    if (controlName === 'unit-count-error') {
      this.unitCountControlErrorVisibility = !this.unitCountControlErrorVisibility;
    }
    if (controlName === 'position') {
      this.controlPositionsVisibility = !this.controlPositionsVisibility;
      this.resetLastClickPosition();
    }
  }

  onClick(event) {
    this.lastClickPosition = new LatLng(
      this.roundCoord(event.latlng.lat),
      this.roundCoord(event.latlng.lng)
    );
    this.changeDetector.detectChanges();
  }
  roundCoord(coord) {
    return Math.round(coord * 1e6) / 1e6;
  }
  onMouseMove(event) {
    this.currentPosition = new LatLng(
      this.roundCoord(event.latlng.lat),
      this.roundCoord(event.latlng.lng)
    );
    this.changeDetector.detectChanges();
  }

  onCopyClick(event) {
    this.clipboard.copyFromContent(`${this.lastClickPosition.lat}, ${this.lastClickPosition.lng}`);
    this.notificationsService.success(this.translateService.instant('Coordinated were copied to clipboard'));
    event.stopPropagation();
    return false;
  }
}
